export const ROOT = "/admin/group";
export const DETAIL_PAGE = `${ROOT}/:groupId`;
